module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00077-fs8.8834bad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00077-fs8.png
// module id = 230
// module chunks = 0